var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurgerMenu = function SvgBurgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 18 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#060A2D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M14 13.716H1m16-6H1m7.5-6H1"
  })));
};
export default SvgBurgerMenu;